module.exports = require('./ComponentView').extend({
  events: {}
});
